<template>
  <div class="verse-widget">
    <v-icon
      size="80"
      :color="$vuetify.theme.dark ? 'brown lighten-3' : 'brown'"
      class="verse-icon"
    >
      {{ icons.mdiBookOpenPageVariant }}
    </v-icon>
    <div v-if="loading" class="text-center py-4">
      <v-progress-circular indeterminate size="24" color="primary" />
    </div>
    <div v-else>
      <div class="verse-text font-italic">
        "{{ verse.text }}"
      </div>
      <div class="verse-ref text-subtitle-2 primary--text mt-2">
        — {{ verse.reference }}
      </div>
      <div v-if="verse.copyright" class="verse-copyright text-caption mt-1">
        {{ verse.copyright }}
      </div>
    </div>
  </div>
</template>

<script>
import { mdiBookOpenPageVariant } from '@mdi/js';
import { clients } from '../../../util/clients';

export default {
  name: 'VerseOfTheDayWidget',
  data: () => ({
    icons: { mdiBookOpenPageVariant },
    verse: {
      text: '',
      reference: '',
      copyright: '',
    },
    loading: true,
  }),
  created() {
    this.loadVerse();
  },
  methods: {
    async loadVerse() {
      try {
        const { backendRest } = clients.direct;
        const { data } = await backendRest.get('/dashboard/verse-of-the-day');
        this.verse = data;
      } catch (err) {
        this.verse = {
          text: 'For God so loved the world, that he gave his only Son, that whoever believes in him should not perish but have eternal life.',
          reference: 'John 3:16 (ESV)',
          copyright: 'ESV® Bible © 2001 Crossway',
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.verse-widget {
  position: relative;
}

.verse-icon {
  position: absolute;
  top: -4px;
  right: 0;
  /* 0.06 of a dark brown on white is a faint ghost; the same 0.06 of a light brown on #1e1e1e
     disappears outright, so the dark theme gets a little more of it. */
  opacity: var(--widget-watermark-opacity, 0.06);
}

.verse-text {
  line-height: 1.7;
  color: var(--widget-verse-text, #4e342e);
  font-size: 15px;
  position: relative;
  z-index: 1;
}

.verse-ref {
  font-weight: 600;
}

.verse-copyright {
  color: var(--widget-muted-text, #9e9e9e);
  font-size: 11px;
}
</style>
